import React, { useContext } from 'react';
import Swal from 'sweetalert2';
import { FaTimes } from 'react-icons/fa';
import { ReportContext } from '../../ReportContext';

const RequestRevision = ({ solutionId }) => {
  const {rejectProposal} = useContext(ReportContext)
  async function handleReject() {
    const confirmResult = await Swal.fire({
      title: 'Confirm Rejection',
      text: 'Are you sure you want to reject?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, reject',
      cancelButtonText: 'Cancel',
    });

    if (confirmResult.isConfirmed) {
      const sessionKey = `rejection_notes_${solutionId}`;
      const savedDraft = sessionStorage.getItem(sessionKey) || '';

      const { value: notes } = await Swal.fire({
        title: 'Revision Notes',
        input: 'textarea',
        // width: '50vw',
        inputLabel: 'Please enter your revision notes',
        inputPlaceholder: 'Type your notes here...',
        inputValue: savedDraft,
        inputAttributes: {
          'aria-label': 'Revision notes',
          style: 'height:30vh;',
        },
        showCancelButton: true,
        didOpen: () => {
          const textarea = Swal.getInput();
          if (textarea) {
            textarea.addEventListener('input', (e) => {
              sessionStorage.setItem(sessionKey, e.target.value);
            });
          }
        },
        preConfirm: (value) => {
          if (!value || !value.trim()) {
            Swal.showValidationMessage('Revision notes cannot be empty');
          }
          return value;
        },
      });

      if (notes) {
        // Submit the rejection notes here
        const response = await rejectProposal({solution_id:solutionId,notes:notes})
        // console.log('Rejected with notes:', notes);
        if (response?.status === 'success'){
          sessionStorage.removeItem(sessionKey); // Clear draft
          Swal.fire('Rejected', 'Your revision notes have been recorded.', 'success');
        }
      }
    }
  }

  return (
    <button
      className="btn btn-outline-danger btn-sm"
      title="Reject"
      onClick={handleReject}
    >
      <FaTimes />
    </button>
  );
};

export default RequestRevision;
